import React from "react";

export default function DailySales({
  total,
  total_amount,
  total_visitor,
  IconName,
  iconColor,
  VisitorIcon,
  AmountIcon,
  desc,
  text,
  note,
  total_cash,
  total_electronic,
  ElectronicIcon,
  CashIcon,
  texts,
  notes,
}) {
  const summaryCards = [
    { Icon: IconName, value: total || 0, label: desc, color: '#3B82F6' },
    { Icon: VisitorIcon, value: total_visitor || 0, label: text, color: '#10B981' },
    { Icon: CashIcon, value: total_cash || 0, label: texts, color: '#F59E0B' },
    { Icon: ElectronicIcon, value: total_electronic || 0, label: notes, color: '#8B5CF6' },
    { Icon: AmountIcon, value: total_amount || 0, label: note, color: '#EF4444' },
  ];

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 py-4">
        {summaryCards.map((card, index) => (
          <div
            key={index}
            className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 p-6 border border-gray-100 hover:-translate-y-1"
          >
            <div className="flex items-start justify-between mb-4">
              <div
                className="w-12 h-12 rounded-lg flex items-center justify-center shadow-sm"
                style={{ backgroundColor: card.color }}
              >
                <card.Icon className="text-white" style={{ fontSize: 25 }} />
              </div>
            </div>
            <div className="mt-2">
              <p className="text-2xl font-bold text-gray-800 mb-1">
                {card.value.toLocaleString()}
              </p>
              <p className="text-sm text-gray-500 font-medium">
                {card.label}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="border-t border-gray-200 my-4" />
    </>
  );
}
